const REGEX_EMAIL = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@' +
    '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)',
    popUpActions = jQuery('div.popupActions'),
    emailTextarea = jQuery('#shareToEmailTextarea', popUpActions);

emailTextarea.selectize({
    plugins: ['remove_button'],
    persist: false,
    maxItems: 30,
    valueField: 'email',
    labelField: 'email',
    searchField: 'email',
    options: [],
    render: {
        item: function (item, escape) {
            return '<div>' +
                (item.email ? '<span class="email">' + escape(item.email) + '</span>' : '') +
                '</div>';
        },
        option: function (item, escape) {
            let label = item.email;
            return '<div>' +
                '<span class="label">' + escape(label) + '</span>'  +
                '</div>';
        }
    },
    createFilter: function (input) {
        var match, regex;

        // email@address.com
        regex = new RegExp('^' + REGEX_EMAIL + '$', 'i');
        match = input.match(regex);
        if (match) return !this.options.hasOwnProperty(match[0]);

        // name <email@address.com>
        regex = new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i');
        match = input.match(regex);
        if (match) return !this.options.hasOwnProperty(match[2]);

        return false;
    },
    create: function (input) {
        if ((new RegExp('^' + REGEX_EMAIL + '$', 'i')).test(input)) {
            return {email: input};
        }
        let match = input.match(new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i'));
        if (match) {
            return {
                email: match[2],
            };
        }
        return false;
    },
    load: function (query, callback) {
        $.get("/share?q=" + query, function (data) {
            callback(data);
        });

    }
});
